<template>
  <ul class="social-links">
    <li
      v-for="social in socialLinks"
      :key="social.id"
      class="social-links-list-item"
    >
      <a
        v-if="social.href"
        :href="social.href"
        target="_blank"
        rel="noopener noreferrer"
        class="social-links-link"
        :aria-label="social.label"
      >
        <Linkedin
          v-if="social.name === 'linkedin'"
          class="icon"
        />
        <Facebook
          v-if="social.name === 'facebook'"
          class="icon"
        />
        <Youtube
          v-if="social.name === 'youtube'"
          class="icon"
        />
        <Pinterest
          v-if="social.name === 'pinterest'"
          class="icon"
        />
        <Instagram
          v-if="social.name === 'instagram'"
          class="icon"
        />
        <Twitter
          v-if="social.name === 'twitter'"
          class="icon"
        />
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SocialLinks',
  components: {
    Facebook: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Facebook.vue'),
    Youtube: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Youtube.vue'),
    Linkedin: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Linkedin.vue'),
    Pinterest: () => import(/* webpackChunkName: "main" */ '@/components/svg/Pinterest.vue'),
    Instagram: () => import(/* webpackChunkName: "main" */ '@/components/svg/Instagram.vue'),
    Twitter: () => import(/* webpackChunkName: "main" */ '@/components/svg/Twitter.vue')
  },
  props: {
    socialLinks: {
      type: Array,
      default: null,
    },
  },

};
</script>

<style lang="postcss" scoped>
.social-links {
  @apply flex flex-row flex-wrap justify-center list-none gap-6;

  @screen md {
    @apply gap-0;
  }

  &-link {
    @apply flex justify-center items-center;
    background: theme('colors.primary.bravo');
    border-radius: 50%;
    color: theme('colors.white');
    margin: 0 10px;
    width: 40px;
    height: 40px;

    &:hover {
      @apply bg-secondary-alpha;
    }

    >>> .icon {
      @apply text-white;
      width: 20px;
      height: 20px;
    }
  }
}
</style>
